import { suggestions, loading, error, pagination, filters, allSuggestions } from '../state'
import { suggestionsService } from '../../../services/suggestions/suggestions-service'
import { useAssetStore } from '@/stores'

/**
 * Tüm önerileri getirir ve client-side filtreleme/sayfalama yapar
 * @param {Object} filterParams - Filtre parametreleri
 * @returns {Promise<void>}
 */
export const fetchSuggestions = async (filterParams = {}) => {
  try {
    // Store'dan assetId'yi al - Fonksiyon içinde çağırıyoruz!
    const assetStore = useAssetStore()
    const assetId = assetStore.assetId
    
    loading.value = true
    error.value = null
    
    // Backend'den tüm önerileri getir
    const response = await suggestionsService.fetchSuggestions({ assetId })

    if (response.success && response.data) {
      // Tüm verileri sakla
      allSuggestions.value = response.data
      
      // Client-side filtreleme ve sayfalama yap
      applyFiltersAndPagination(filterParams)
    } else {
      error.value = 'Öneriler yüklenirken bir hata oluştu'
      suggestions.value = []
      pagination.total = 0
      pagination.pages = 0
    }

  } catch (err) {
    console.error('Error fetching suggestions:', err)
    error.value = 'Öneriler yüklenirken bir hata oluştu'
    suggestions.value = []
    pagination.total = 0
    pagination.pages = 0
  } finally {
    loading.value = false
  }
}

/**
 * Mevcut filtreleri uygular ve sayfalamayı günceller
 * @param {Object} filterParams - Uygulanan filtre parametreleri (opsiyonel)
 */
export const applyFiltersAndPagination = (filterParams = {}) => {
  try {
    // Filtreleme parametrelerini güncelle (eğer varsa)
    if (filterParams.contentType !== undefined) filters.contentType = filterParams.contentType
    if (filterParams.contentCategory !== undefined) filters.contentCategory = filterParams.contentCategory
    if (filterParams.contentId !== undefined) filters.contentId = filterParams.contentId
    if (filterParams.assetId !== undefined) filters.assetId = filterParams.assetId
    if (filterParams.priority !== undefined) filters.priority = filterParams.priority
    if (filterParams.page !== undefined) pagination.page = filterParams.page
    if (filterParams.limit !== undefined) pagination.limit = filterParams.limit
    
    // Filtre koşullarını oluştur
    let filteredData = [...allSuggestions.value]
    
    // contentType filtresi
    if (filters.contentType) {
      filteredData = filteredData.filter(item => item.contentType === filters.contentType)
    }
    
    // contentCategory filtresi
    if (filters.contentCategory) {
      filteredData = filteredData.filter(item => item.contentCategory === filters.contentCategory)
    }
    
    // contentId filtresi
    if (filters.contentId) {
      filteredData = filteredData.filter(item => item.contentId === filters.contentId)
    }
    
    // priority filtresi - sayıya dönüştürme gerekiyor
    if (filters.priority) {
      const priorityNumber = parseInt(filters.priority, 10)
      if (!isNaN(priorityNumber)) {
        filteredData = filteredData.filter(item => item.priority === priorityNumber)
      }
    }
    
    // Toplam sayı ve sayfa sayısını güncelle
    pagination.total = filteredData.length
    pagination.pages = Math.ceil(filteredData.length / pagination.limit)
    
    // Sayfalama uygula
    const startIndex = (pagination.page - 1) * pagination.limit
    const endIndex = startIndex + pagination.limit
    
    // Sonuçları güncelle
    suggestions.value = filteredData.slice(startIndex, endIndex)
    
    return suggestions.value
  } catch (err) {
    console.error('Error applying filters:', err)
    error.value = 'Filtreleme işlemi sırasında bir hata oluştu'
    return []
  }
}

/**
 * Belirli bir öneriyi ID ile getirir
 * @param {Number|String} id - Öneri ID'si
 * @returns {Promise<Object|null>} Öneri verisi veya null
 */
export const fetchSuggestionById = async (id) => {
  try {
    // Store'dan assetId'yi al - Fonksiyon içinde çağırıyoruz!
    const assetStore = useAssetStore()
    const assetId = assetStore.assetId
    
    loading.value = true
    error.value = null

    const response = await suggestionsService.fetchSuggestionById(id, { assetId })

    if (response.success && response.data) {
      return response.data
    } else {
      error.value = 'Öneri bulunamadı'
      return null
    }

  } catch (err) {
    console.error(`Error fetching suggestion with id ${id}:`, err)
    error.value = 'Öneri yüklenirken bir hata oluştu'
    return null
  } finally {
    loading.value = false
  }
}
